module.exports = __webpack_public_path__ + "static/img/12.e91afeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/12.png
// module id = br0D
// module chunks = 0